export default "__VITE_PUBLIC_ASSET__8d1e3514__"